var _path, _rect, _path2, _rect2, _path3, _rect3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgStepThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 30,
    viewBox: "0 0 209 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 15h173",
    stroke: "#B7C6D7",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#41F2E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.096 18.78h.001a.705.705 0 0 0 .994 0l6.563-6.564a.705.705 0 0 0 0-.994v-.001a.705.705 0 0 0-.995 0l-6.065 6.066-3.253-3.253a.705.705 0 0 0-.994 0h-.001a.705.705 0 0 0 0 .995l3.75 3.75ZM9.82 14.062a.47.47 0 0 0-.307.8l3.75 3.75-3.75-3.75a.47.47 0 0 1 .307-.8Zm10.312-2.812a.469.469 0 0 0-.307.136l-6.23 6.232 6.23-6.232a.47.47 0 0 1 .307-.136Z",
    fill: "#343741"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#41F2E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.096 18.78h.001a.705.705 0 0 0 .994 0l6.563-6.564a.704.704 0 0 0 0-.994l-.001-.001a.704.704 0 0 0-.994 0l-6.065 6.066-3.253-3.253a.704.704 0 0 0-.994 0h-.001a.705.705 0 0 0 0 .995l3.75 3.75Zm-3.277-4.717a.468.468 0 0 0-.307.8l3.75 3.75-3.75-3.75a.47.47 0 0 1 .307-.8Zm10.313-2.812a.47.47 0 0 0-.308.136l-6.23 6.232 6.231-6.232a.466.466 0 0 1 .307-.136Z",
    fill: "#343741"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FEDD0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.795 20.689c-.499 0-.968-.093-1.407-.28a3.353 3.353 0 0 1-1.141-.812 3.214 3.214 0 0 1-.693-1.239l1.414-.392c.135.434.371.768.707 1.001.336.229.709.34 1.12.336.369-.005.693-.091.973-.259s.499-.394.658-.679c.159-.29.238-.62.238-.994 0-.56-.175-1.022-.525-1.386-.345-.364-.798-.546-1.358-.546-.159 0-.322.023-.49.07a2.523 2.523 0 0 0-.462.182l-.686-1.155 3.556-3.143.154.42h-4.9V10.42h6.062v1.393l-2.954 2.842-.014-.476c.635 0 1.185.142 1.652.427.467.28.826.663 1.078 1.148.257.48.385 1.02.385 1.617 0 .644-.152 1.216-.455 1.715a3.22 3.22 0 0 1-1.211 1.176 3.397 3.397 0 0 1-1.701.427Z",
    fill: "#292929"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepThree);
export default __webpack_public_path__ + "static/media/StepThree.4a8fa04badc0a87b1f6526af18ea6ed3.svg";
export { ForwardRef as ReactComponent };